import type { Json } from '@/types/database.generated';
import { supabase } from '@/lib/supabase';

const CLINIC_LOGOS_PREFIX = 'clinic-logos/';

/** Reads logo URL from clinics.branding JSON (not a top-level column). */
export function logoUrlFromBranding(branding: Json | null | undefined): string | null {
  if (branding && typeof branding === 'object' && !Array.isArray(branding)) {
    const url = (branding as Record<string, unknown>).logo_url;
    return typeof url === 'string' && url.length > 0 ? url : null;
  }
  return null;
}

/** Resolve a stored logo_url (storage path or external URL) to an <img> src. */
export function resolveClinicLogoUrl(logoUrl: string | null | undefined): string | null {
  if (!logoUrl) return null;
  if (logoUrl.startsWith('http://') || logoUrl.startsWith('https://')) return logoUrl;
  if (!logoUrl.startsWith(CLINIC_LOGOS_PREFIX)) return logoUrl;

  const path = logoUrl.slice(CLINIC_LOGOS_PREFIX.length);
  const { data } = supabase.storage.from('clinic-logos').getPublicUrl(path);
  return data.publicUrl || null;
}
